import examples from 'libphonenumber-js/mobile/examples';
import { AsYouType, CountryCode, getExampleNumber, parsePhoneNumber } from "libphonenumber-js";

export function formatInternationalPhoneNumber(phoneNumber: string, countryCode: CountryCode): string {
    if(!phoneNumber || !countryCode) {
        return '';
    }

    const parsedPhoneNumber = parsePhoneNumber(phoneNumber, countryCode);
    if(!parsedPhoneNumber) {
        console.debug(`Unable to parse phone number: ${phoneNumber}`);
        return '';
    }

    return parsedPhoneNumber.formatInternational();
}

export function formatNationalPhoneNumber(phoneNumber: string, countryCode: CountryCode): string {
    if(!phoneNumber || !countryCode) {
        return '';
    }

    const parsedPhoneNumber = parsePhoneNumber(phoneNumber, countryCode);
    if(!parsedPhoneNumber) {
        console.debug(`Unable to parse phone number: ${phoneNumber}`);
        return '';
    }

    return parsedPhoneNumber.formatNational();
}

export function formatPhoneNumber(phoneNumber: string, countryCode: CountryCode): string {
    if(!phoneNumber || !countryCode) {
        return '';
    }

    if(phoneNumber.includes('(') && !phoneNumber.includes(')')) {
        return phoneNumber.replace('(', '');
    }

    return new AsYouType(countryCode).input(phoneNumber);
}

export function validatePhoneNumber(phoneNumber: string, countryCode: CountryCode): boolean {
    if(!phoneNumber || !countryCode) {
        return false;
    }

    const parsedPhoneNumber = parsePhoneNumber(phoneNumber, countryCode);
    return parsedPhoneNumber?.isValid() ?? false;
}

export function getPhoneNumberFormatHint(countryCode: CountryCode): string {
    if(!countryCode) {
        return '';
    }

    const examplePhoneNumber = getExampleNumber(countryCode, examples);
    return formatNationalPhoneNumber(String(examplePhoneNumber?.nationalNumber), countryCode);
}